import React from "react";

const CarouselPlaceholder = (): JSX.Element => (
  <div id="h-[318px] lg:h-[446px]"></div>
);

export default CarouselPlaceholder;
